// Shared by the client feedback notes list and the feedback history.

// Local date, so feedback given in the evening isn't shown as the next day
export function formatFeedbackDate(dateString) {
    return new Date(dateString).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
}

// A feedback or note row's campaign is only worth naming when it isn't the one the company is in now
export function isFromAnotherCampaign(row, company) {
    return Boolean(row.campaign) && row.campaign.id !== company.campaign?.id
}
